import { Enum } from '@/helpers/enum'
import { API } from '@/models/core'

export const CricketPlayerRole = new Enum({
  Batsman: 'batsman',
  AllRounder: 'allrounder',
  Keeper: 'keeper',
  Bowler: 'bowler',
  Unknown: 'unknown'
})

export const CricketPlayerRoleOrder = [
  { keys: [CricketPlayerRole.Batsman.key], name: 'Batsman' },
  { keys: [CricketPlayerRole.AllRounder.key], name: 'All Rounder' },
  { keys: [CricketPlayerRole.Keeper.key], name: 'Keeper' },
  { keys: [CricketPlayerRole.Bowler.key], name: 'Bowler' },
  { keys: null, name: 'Others' },
  { keys: 'not_found', name: 'Not Found' }
]

export class CricketPlayer {
  get groupingRole () {
    if (this.isValidSeasonRole) {
      return CricketPlayerRole.praseSafe(this.seasonal_role)
    }

    return CricketPlayerRole.Unknown
  }

  get fantasyRole () {
    return this.groupingRole
  }

  get role () {
    let possibleRole = null

    if (this.identified_roles) {
      if (this.identified_roles.batsman) {
        possibleRole = CricketPlayerRole.Batsman
      }

      if (this.identified_roles.bowler) {
        if (possibleRole === CricketPlayerRole.Batsman) {
          possibleRole = CricketPlayerRole.AllRounder
        } else {
          possibleRole = CricketPlayerRole.Bowler
        }
      }

      if (this.identified_roles.keeper) {
        possibleRole = CricketPlayerRole.Keeper
      }
    }
    return possibleRole
  }

  get isSeasonalRoleDifferent () {
    const possibleRole = CricketPlayerRole.praseSafe(this.seasonal_role)
    return possibleRole !== this.role
  }

  get isValidSeasonRole () {
    const possibleRole = CricketPlayerRole.praseSafe(this.seasonal_role)
    return possibleRole != null
  }

  static fetchStats (key) {
    return API.instance().get(`/cricket/player/${key}/stats/`).then((resp) => {
      const raw = resp.data.data
      const stats = raw.stats
      const player = CricketPlayer.createFromJson(raw.player.key, raw.player)
      return { player, stats }
    })
  }

  static fetchProfile (key) {
    return API.instance().get(`/cricket/player/${key}/`).then((resp) => {
      const raw = resp.data.data
      const player = CricketPlayer.createFromJson(raw.player.key, raw.player)
      return player
    })
  }

  static createFromJson (key, raw) {
    let player = new CricketPlayer()
    player = Object.assign(player, raw)
    player.key = key
    return player
  }
}

CricketPlayer.State = {
  selected: null
}
